export function array_diff(array1, array2) {
    return array1.filter(function(i) {
        return array2.indexOf(i) < 0;
    });
}
export function trans(translations, name, path) {
    path = path ? `${path}.${name}` : name;
    let parts = path.split('.');
    let trans = translations;

    for (let i = 0; i < parts.length; i++) {
        if (!(parts[i] in trans)) {
            return `trans(${path})`;
        }

        trans = trans[parts[i]];

        if (i === (parts.length - 1)) {
            return trans;
        }
    }
}
